export const getHotPreparationKitchenAreaByName = (kitchenAreas = []) => {
  return kitchenAreas.find(kitchenArea => kitchenArea.name.match(new RegExp("prépa chaude", "ig")) !== null)
}